import { Create, SimpleForm } from "react-admin";
import {
  DicomNodeClientFields,
  DicomNodeOutputOptionFields,
  DicomNodeGroupField,
  DicomNodeServerFields,
} from "./DicomNodeForm";

export const DicomNodeCreate = () => (
  <Create redirect="list">
    <SimpleForm mode="onBlur" reValidateMode="onBlur">
      <DicomNodeGroupField />
      <DicomNodeServerFields />
      <DicomNodeClientFields />
      <DicomNodeOutputOptionFields />
    </SimpleForm>
  </Create>
);
